import { BrowserRouter, Route, Routes } from "react-router-dom";
import ErrorBoundary from "./ErrorBoundary";
import "./components/css/admin.css";
import "./components/css/mdb.min.css";
import "./components/css/responsive.css";
import ACDQueuesSettings from "./components/editviews/acd/ACDQueuesSettings";
import UserEditMain from "./components/editviews/user/Main";
import SMSGroupsEditMain from "./components/editviews/user/SMSGroupsEditMain";
import LocationsUsers from "./components/topviews/LocationsUsers";
import RolesAndPermissions from "./components/topviews/RolesAndPermissions";
import StreamTeams from "./components/topviews/StreamTeam";
import UsersPartOfGroup from "./components/topviews/UsersPartOfGroup";
import ACDQueues from "./views/ACDQueues";
import APIDetails from "./views/APIDetails";
import AccInfo from "./views/AccInfo";
import AdminHelp from "./views/AdminHelp";
import DirectoriesSettings from "./views/DirectoriesSettings";
import DragPopup from "./views/DragPopup";
import FaxGroupsDetails from "./views/FaxGroupsDetails";
import HuntGroupDetails from "./views/HuntGroupDetails";
import IpphonesAddDevice from "./views/IpPhonesAddDevice";
import { default as IpPopups, default as Popups } from "./views/IpphonesAndDevicesPopups";
import LandingPage from "./views/LandingPage";
import Location911OnlySettings from "./views/Location911OnlySettings";
import Login from "./views/Login";
import ManualDeviceSettings from "./views/ManualDeviceSettings";
import MediaManagementPopups from "./views/MediaManagementPopups";
import PoolEdit from "./views/PoolEdit";
import PhoneNumbers from "./views/PhoneNumbers";
import SelectedAdminRoleSettings from "./views/SelectedAdminRoleSettings";
import SelectedPagingGroups from "./views/SelectedPagingGroups";
import SelectedTeamSettings from "./views/SelectedTeamSettings";
import SelectedUserGroupSettings from "./views/SelectedUserGroupSettings";
import VMSettings from "./views/VMSettings";
import WeelySchedule from "./views/WeelySchedule";
import AutoAttendant from "./views/autoattendant";
import BLFDetails from "./views/blfdetails";
import FileNotFound from "./views/errorpages/404";
import HuntGroup from "./views/huntgroup";
import AccountInfoLanding from "./views/landingpages/AccountInfoLanding";
import AccountSettingsLanding from "./views/landingpages/AccountSettingsLanding";
import AnalyticsLandingPage from "./views/landingpages/AnalyticsLanding";
import BillingLandingPage from "./views/landingpages/BillingLanging";
import BrandCompanyRegistration from "./views/landingpages/BrandCompanyRegistration";
import CallFlowLanding from "./views/landingpages/CallFlowLanding";
import ContactsLanding from "./views/landingpages/ContactsLanding";
import FaxGroupsLandingPage from "./views/landingpages/FaxGroupsLandingPage";
import LocLandingPage from "./views/landingpages/LocLanding";
import MediaLanding from "./views/landingpages/MediaLanding";
import OrgGroupsLandingPage from "./views/landingpages/OrgGroupsLandingPage";
import PSLandingPage from "./views/landingpages/PSLanding";
import SMSCampaignRegistration from "./views/landingpages/SMSCampaignRegistration";
import SMSLandingPage from "./views/landingpages/SMSLanding";
import SecurityRegistration from "./views/landingpages/securitymanager/SecurityRegistration";
import SpamAndBlockingLanding from "./views/landingpages/SpamAndBlockingLanding";
import StreamsSettingsLanding from "./views/landingpages/StreamsSettingsLanding";
import UserLandingPage from "./views/landingpages/UserLanding";
import VMLandingPage from "./views/landingpages/vmLandingpage";
import LocDetails from "./views/locDetails";
import Locationtopview from "./views/locationtopview";
import CallFlowGeneralSettings from "./views/popups/callflow/CallFlowGeneralSettings";
import PhoneNumbersDetails from "./views/popups/phonenumbers/PhoneNumberDetails";
import UserDetails from "./views/userDetails";
import UserSettings from "./views/StreamsSettings/UserSettings";
import Devices from "./views/StreamsSettings/Devices";
import APILandingPage from "./views/landingpages/APILandingPage";
import BillingAccountInfo from "./views/BillingAccountInfo";
import BillingGroupDetails from "./components/editviews/billing/BillingGroupDetails";
import { AdminContextProvider } from "./components/adminstore/Admin-Context";
import UserGeneralSettings from "./components/editviews/user/UserGeneralSettings"
import SMSGroups from "./components/topviews/SMSGroups";
import { auth_signOut_url, authentication_url } from "./apiclients/apiurls";

import VisualEditorNew from "./components/CallFlows12/VisualEditorNew";
import StreamsAPIApps from "./views/landingpages/StreamsAPIApps";
import StreamsApiSettings from "./views/StreamsApiSettings";
import HelpPage from "./views/landingpages/HelpPage";
import PrivacyPolicy from "./views/landingpages/PrivacyPolicy";
import { I18nextProvider } from "react-i18next";
import i18n from './i18n';
import LunaLanding from "./views/landingpages/LunaLanding";
import LunaSettings from "./components/editviews/luna/LunaSettings";
import DialbyNameDirectoriesLanding from "./views/landingpages/DialbyNameDirectoriesLanding";
import DailByDirectoriesSettings from "./components/topviews/DailByDirectoriesSettings";
import GlobalSettings from "./views/landingpages/GlobalSettings";
import SecurityLanding from "./views/landingpages/SecurityLanding";
import SendFax from "./components/editviews/user/SendFax";
import OnlineDevices from "./components/topviews/phonesanddevices/OnlineDevices";
import { store } from "./ai-chat-buddy/store/GlobalStore.ts";
import { Provider } from 'react-redux';
import MSEntraIDLanding from "./views/landingpages/MSEntraIDLanding";
import SSODownloadRedirect from "./views/validators/ms-entra-helper";
import UsageSummary from "./components/topviews/UsageSummary.js";
import ReputationLanding from "./views/landingpages/ReputationLanding.js";
import ReputationSettings from "./views/ReputationSettings.js";


import StreamsManagerLanding from "./views/landingpages/StreamsManagerLanding.js";
import { useEffect, useState } from "react";
import Heatmap from "./components/heatMap.jsx";
import YealinkSettings from "./views/Yealink/YealinkSettings.js";
import HeatMapValidation from "./components/HeatMapValidation.jsx";

function setToken(userToken) {
  try {
    sessionStorage.setItem("token", userToken);
  } catch (e) {
    console.log("Error while creating session.. " + e);
  }
}

function getToken() {
  try {
    const tokenString = sessionStorage.getItem("token");
    const userToken = JSON.parse(tokenString);
    return userToken;
  } catch (e) {
    console.log("error :::::: " + e);
    return;
  }
}
const allowedStreamsRoutes = [
  "/userGeneralsettings",
  "/send-fax",
  "/onlineDevices"
  // add other allowed routes here
];

// Global route guard
const AuthGuard = ({ children }) => {
  const adminSession = sessionStorage.getItem("admin_session");
  const pathname = window.location.pathname;

  // Special rule for heatmap/view-info
  if (pathname === "/heatmap/view-info") {
    const heatmapToken = sessionStorage.getItem("heatmaptoken");

    if (!heatmapToken) {
      // Redirect to 404 if token missing
      window.location.href = "/pageNotFound";
      return null;
    }

    // Token exists → allow
    return children;
  }

  // Public paths (no auth required)
  const publicPaths = [
    "/heatmap"
  ];

  if (publicPaths.includes(pathname)) {
    return children;
  }

  // Redirect to login if not authenticated
  if (!adminSession && window.location.pathname !== "/login") {
    window.location.href = authentication_url;
    return null;
  }

  if (adminSession) {
    const StreamsReq = JSON.parse(adminSession)?.isStreamReq
    const isStreamReq = StreamsReq && (StreamsReq === 1 || StreamsReq === 2) ? true : false;
    if (isStreamReq && !allowedStreamsRoutes.includes(window.location.pathname)) {
      if (window.location.pathname !== "/pageNotFound") {
        window.location.href = "/pageNotFound";
        return null;
      }
    }
  }

  return children;
};


// Hide the loader
const loader = document.getElementById('global-loader');
if (loader) {
  loader.style.display = 'none';
}


function App() {
  const token = getToken();
  console.log("Token ... " + token);
  if (!token) {
    //window.
    //  return <Login setToken={setToken} />;
  }

  // const [appReady, setAppReady] = useState(false);
  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     setAppReady(true);
  //     const loader = document.getElementById("global-loader");
  //     if (loader) loader.style.display = "none";
  //   }, 1000); 
  //   return () => clearTimeout(timer);
  // }, []);

  return (
    <>
      <Provider store={store}>
        <I18nextProvider i18n={i18n} defaultNS={'translation'}>
          <AdminContextProvider>
            <ErrorBoundary>
              <BrowserRouter>
                <AuthGuard>
                  <Routes>
                    <Route path="/*" element={<FileNotFound />} />
                    <Route path="/" index element={<Login />} />
                    <Route path="/pageNotFound" element={<FileNotFound />} />
                    <Route path="/login" index element={<Login setToken={setToken} />} />
                    <Route path="/home" index element={<LandingPage />} />
                    <Route path="/loclanding" index element={<LocLandingPage />} />
                    <Route path="/pslanding" index element={<PSLandingPage />} />
                    <Route path="/userlanding" index element={<UserLandingPage />} />
                    <Route path="/analyticslanding" index element={<AnalyticsLandingPage />} />
                    <Route path="/vmlanding" index element={<VMLandingPage />} />
                    <Route path="/vmsettings" index element={<VMSettings />} />
                    <Route path="/billinglanding" index element={<BillingLandingPage />} />
                    <Route path="/apilanding" index element={<APILandingPage />} />
                    <Route path="/smslanding" index element={<SMSLandingPage />} />
                    <Route path="/accinfo" index element={<AccInfo />} />
                    <Route path="/ippopups" index element={<IpPopups />} />
                    <Route path="/blfdetails" index element={<BLFDetails />} />
                    <Route path="/autoattendant" index element={<AutoAttendant />} />
                    <Route path="/huntaccinfo" index element={<HuntGroupDetails />} />
                    <Route path="/huntgroup" index element={<HuntGroup />} />
                    <Route path="/acdQueues" index element={<ACDQueues />} />
                    <Route path="/popups" index element={<Popups />} />
                    <Route path="/locationtopview" index element={<Locationtopview />} />
                    <Route path="/locDetails" index element={<LocDetails />} />
                    <Route path="/ipphoneadd" index element={<IpphonesAddDevice />} />
                    <Route path="/weelySchedule" index element={<WeelySchedule />} />
                    <Route path="/userDetails" index element={<UserDetails />} />
                    <Route path="/location911settings" index element={<Location911OnlySettings />} />
                    <Route path="/selectedusergroupsettings" index element={<SelectedUserGroupSettings />} />
                    <Route path="/streamsteamssection" index element={<StreamTeams />} />
                    <Route path="/selectedteamsettings" index element={<SelectedTeamSettings />} />
                    <Route path="/permissionrolessection" index element={<RolesAndPermissions />} />
                    <Route path="/manualdevicesettings" index element={<ManualDeviceSettings />} />
                    <Route path="/roleedit" index element={<SelectedAdminRoleSettings />} />
                    <Route path="/acdqueuessettings" index element={<ACDQueuesSettings />} />
                    <Route path="/useredit" index element={<UserEditMain />} />
                    <Route path="/phonenumbers" index element={<PhoneNumbers />} />
                    <Route path="/selectedpaginggroups" index element={<SelectedPagingGroups />} />
                    <Route path="/mediamanagementpopups" index element={<MediaManagementPopups />} />
                    <Route path="/directoriessettings" index element={<DirectoriesSettings />} />
                    <Route path="/medialanding" index element={<MediaLanding />} />
                    <Route path="/callflowlanding" index element={<CallFlowLanding />} />

                    {/* Call Flow version 12 routes */}
                    <Route path="/ai-call-flow" index element={<VisualEditorNew />} />

                    <Route path="/contactslanding" index element={<ContactsLanding />} />
                    <Route path="/securityregistrationlanding" index element={<SecurityRegistration />} />
                    <Route path="/spamblocking" index element={<SpamAndBlockingLanding />} />
                    <Route path="/phonenumberdetails" index element={<PhoneNumbersDetails />} />
                    <Route path="/callflowedit" index element={<CallFlowGeneralSettings />} />
                    <Route path="/drag" index element={<DragPopup />} />
                    <Route path="/apidetails" index element={<APIDetails />} />
                    <Route path="/accountsettings" index element={<AccountSettingsLanding />} />
                    <Route path="/streamssettings" index element={<StreamsSettingsLanding />} />
                    <Route path="/locationsusers" index element={<LocationsUsers />} />
                    <Route path="/usersgroups" index element={<UsersPartOfGroup />} />
                    <Route path="/smsgroupseditmain" index element={<SMSGroupsEditMain />} />
                    <Route path="/accountinfolanding" index element={<AccountInfoLanding />} />
                    <Route path="/brandcompanyregistration" index element={<BrandCompanyRegistration />} />
                    <Route path="/smscampaignregistration" index element={<SMSCampaignRegistration />} />
                    <Route path="/faxgroupslandingpage" index element={<FaxGroupsLandingPage />} />
                    <Route path="/send-fax" index element={<SendFax />} />
                    <Route path="/orggroupslandingpage" index element={<OrgGroupsLandingPage />} />
                    <Route path="/pooledit" index element={<PoolEdit />} />
                    <Route path="/faxgroupsdetails" index element={<FaxGroupsDetails />} />
                    <Route path="/help" index element={<AdminHelp />} />
                    <Route path="/usersettings" index element={<UserSettings />} />
                    <Route path="/devices" index element={<Devices />} />
                    <Route path="/billingaccountinfo" index element={<BillingAccountInfo />} />
                    <Route path="/billinggroupdetails" index element={<BillingGroupDetails />} />
                    <Route path="/userGeneralsettings" index element={<UserGeneralSettings />} />
                    <Route path="/smsgroupslanding" index element={<SMSGroups />} />
                    <Route path="/streamsapiapps" index element={<StreamsAPIApps />} />
                    <Route path="/streamsapisettings" index element={<StreamsApiSettings />} />
                    <Route path="/helppage" index element={<HelpPage />} />
                    <Route path="/privacypolicy" index element={<PrivacyPolicy />} />
                    <Route path="/dialbydirectoriesLanding" index element={<DialbyNameDirectoriesLanding />} />
                    <Route path="/dailbydirectoriessettings" index element={<DailByDirectoriesSettings />} />
                    {/* LUNA AI  */}
                    <Route path="/luna-landing" index element={<LunaLanding />} />
                    <Route path="/luna-settings" index element={<LunaSettings />} />
                    <Route path="/globalsettings" index element={<GlobalSettings />} />
                    <Route path="/Securitylanding" index element={<SecurityLanding />} />
                    <Route path="/msentraidlanding" index element={<MSEntraIDLanding />} />
                    <Route path="/ms-entra-sso/metadata" element={<SSODownloadRedirect />} />
                    <Route path="/onlineDevices" index element={<OnlineDevices />} />
                    <Route path="/usageSummary" index element={<UsageSummary />}
                     />
                     <Route path="/reputationlanding" index element={<ReputationLanding />} />
                    <Route path="/reputationsettings" index element={<ReputationSettings />} />

                    <Route path="/streamsmanager" index element={<StreamsManagerLanding />} />
                    
                    <Route path="/heatmap" element={<HeatMapValidation />} />
                    <Route path="/heatmap/view-info" element={<Heatmap />} />
                  <Route path="/YealinkSettings" index element={<YealinkSettings />} />
                  </Routes>
                </AuthGuard>
              </BrowserRouter>
            </ErrorBoundary>
          </AdminContextProvider>
        </I18nextProvider>
      </Provider>
    </>
  );
}

export default App;
